import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { useSDUIFilterablePaginatedSectionState } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionState";
import { IPaginationData } from "@faire/web-api--source/indigofair/data/IPaginationData";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import { useEffect, useRef } from "react";

// Prefetch next page on page load for RSC. It will be triggered when the page loads on direct load
// or after navigation from a different page. This is to maintain the same behavior as the legacy search page.
export const SDUIFilterablePaginatedSectionPrefetchNextPageOnPageLoad = ({
  paginationData,
  handlePaginationLink,
  isRSC,
}: {
  paginationData: IPaginationData;
  handlePaginationLink: (pageNumber: number) => string;
  isRSC?: boolean;
}) => {
  const { prefetch: nextPrefetch } = useNextRouterContext();
  const { oneIndexedPageNumber, pathname } =
    useSDUIFilterablePaginatedSectionState(!!isRSC);
  const previousPathnameRef = useRef<string | null>(null);

  const pageCount = paginationData?.page_count ?? 0;
  const nextPageNumber = oneIndexedPageNumber + 1;
  const isNextPageAvailable = nextPageNumber <= pageCount && nextPageNumber > 0;

  useEffect(() => {
    if (isNextPageAvailable && previousPathnameRef.current !== pathname) {
      nextPrefetch(handlePaginationLink(nextPageNumber), {
        kind: PrefetchKind.FULL,
      });
    }
    previousPathnameRef.current = pathname;
  }, [pathname]);

  return null;
};
